module.exports = __webpack_public_path__ + "img/migrants-2006.cdbb4312.png";